<template>
	<div data-tour-scope="packing-lists">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ this.$vuetify.lang.t('$vuetify.front.packingList') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()">
								<v-icon left>mdi-school-outline</v-icon>
								Tutorial guidato
							</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- <v-divider vertical></v-divider>-->
								<!--								<v-btn text @click="toggleDrawerFilter">
									<v-icon>mdi-magnify</v-icon>
								</v-btn>-->
								<!-- una sola azione: il "+" porta direttamente alla pagina di avvio -->
								<v-btn elevation="0" text data-tour="add" title="Crea nuova Packing List" @click="openNew">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch()" @keyup.enter="getSearch()" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-menu v-model="datapacking_list" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDatejs" v-on="on" dense clearable @click:clear="cleardate" label="Data ordine" outlined hide-details> </v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.start_date" @change="datapacking_list = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="4">
									<v-select v-model="settings.filters.status" :items="status" multiple dense label="Status" hide-details outlined></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getPackingLists"
							:options.sync="settings.options"
							must-sort
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="item._id"
							:mobile="isMobile"
							:mobile-breakpoint="0"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="packing-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="titoloCard(item)" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-open" @click="editItem(item)">
																<v-list-item-title class="size9">Apri dettaglio</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center flex-wrap mb-2">
														<template v-if="primoOrdine(item)">
															<img :src="getImageMarketplace(primoOrdine(item).Platform)" :alt="primoOrdine(item).Platform" style="height: 22px" />
															<img
																v-if="primoOrdine(item).ShippingAddress && primoOrdine(item).ShippingAddress.Country"
																:src="getImageFlag(primoOrdine(item).ShippingAddress)"
																:alt="primoOrdine(item).ShippingAddress.Country"
																style="height: 14px; margin-left: 5px"
															/>
														</template>
														<v-chip v-if="item.status === 'completed'" label small color="green" text-color="white" class="ml-2">
															<strong>Completata</strong>
														</v-chip>
														<v-chip v-if="item.status === 'in_progress'" label small color="red" text-color="white" class="ml-2">
															<strong>In elaborazione</strong>
														</v-chip>
														<v-spacer></v-spacer>
														<v-btn small text color="primary" data-tour="order-link" @click="editOrder(item)"><v-icon small left>mdi-magnify</v-icon>Ordine</v-btn>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="item in items">
										<tr>
											<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
												<v-menu top eager>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
															<v-icon dark> mdi-dots-vertical </v-icon>
														</v-btn>
													</template>
													<v-list>
														<v-list-item link data-tour="row-open" @click="editItem(item)">
															<v-list-item-title class="size9">Apri dettaglio</v-list-item-title>
														</v-list-item>
													</v-list>
												</v-menu>
											</td>
											<td>{{ item.start_date | moment('DD/MM/YYYY HH:mm:ss') }}</td>
											<td>
												<v-avatar size="32px" tile>
													<img :src="getImageMarketplace(item.order[0].Platform)" :alt="item.order[0].Platform" />
												</v-avatar>
												<v-avatar size="16px" tile style="margin-left: 5px" v-if="item.order[0].ShippingAddress.Country">
													<img :src="getImageFlag(item.order[0].ShippingAddress)" :alt="item.order[0].ShippingAddress" />
												</v-avatar>
											</td>
											<td style="white-space: nowrap">
												{{ item.order_number }}
												<v-btn text data-tour="order-link" @click="editOrder(item)"> <v-icon>mdi-magnify</v-icon></v-btn>
											</td>
											<td>{{ item.order[0].buyer.name }} {{ item.order[0].buyer.lastname }}</td>
											<td>
												<template v-if="item.status === 'completed'">
													<v-chip label small color="green" text-color="white">
														<strong>Completata</strong>
													</v-chip>
												</template>
												<template v-if="item.status === 'in_progress'">
													<v-chip label small color="red" text-color="white">
														<strong>In elaborazione</strong>
													</v-chip>
												</template>
											</td>
											<td>
												<template v-if="item.finish_date">
													{{ item.finish_date | moment('DD/MM/YYYY HH:mm:ss') }}
												</template>
											</td>
											<td>
												<template v-if="item.coupon !== 'false'">
													{{ item.coupon }}
												</template>
											</td>
											<td>
												{{ item.updated_at | moment('DD/MM/YYYY HH:mm:ss') }}
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations, mapActions } from 'vuex';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createPackingListsTourSteps, stopPackingListsTour } from './packing-lists-tour';
import { openWithReturn } from '@/components/core/pageReturn';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'PackingLists',
	// pagina, righe, ordinamento, ricerca e filtri nell'URL: refresh e ritorno dal dettaglio ripartono da li'
	mixins: [listRouteState({ filters: { status: 'array', start_date: 'array' }, perPageOptions: LIST_SIZE })],
	/*
	 * Il controller del tutorial nasce qui e non in `data()`: quello che sta in
	 * `data()` viene reso reattivo in profondita da Vue 2, e in quel passaggio i
	 * `ref` del motore verrebbero srotolati nel loro valore grezzo.
	 */
	setup() {
		return {
			tour: useTour(createPackingListsTourSteps(), { onStop: stopPackingListsTour }),
		};
	},
	data() {
		return {
			loadingDownload: false,
			errorDownloadReview: '',
			modalDownloadReview: false,
			idStart: '',
			idEnd: '',
			componentKey: 0,
			items: [],
			setinterval: '',

			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// ricerca
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					status: [],
					start_date: [],
				},
				options: {
					sortBy: ['start_date'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),

			listSize: LIST_SIZE,
			linkdownload: '',
			searchfield: '',
			selected: [],
			total: 0,
			expanded: [],
			singleExpand: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Data Inizio', value: 'start_date' },
				{ text: 'Piattaforma', value: 'order.Platform' },
				{ text: 'Rif. Ordine', value: 'OrderID' },
				{ text: 'Cliente', value: 'buyer.name' },
				{ text: 'Status', value: 'status' },
				{ text: 'Data Fine', value: 'finish_date' },
				{ text: 'Coupon', value: 'coupon' },
				{ text: 'Data Ultimo Aggiornamento', value: 'updated_at' },
			],

			disabled: false,
			absolute: false,
			openOnHover: false,
			value: false,
			closeOnClick: true,
			closeOnContentClick: true,
			offsetX: false,
			offsetY: true,
			isMobile: true,

			isActive: true,

			show1: false,
			messages: {
				email: [],
				name: [],
				password: [],
			},
			parseDate: [],
			datapacking_list: '',
			datapreparazione: '',
			platform: [],
			packagings: [],
			status: [
				{ value: 'in_progress', text: 'In elaborazione' },
				{ value: 'completed', text: 'Completata' },
			],
			payments: [],
			agents: [],
			choosePlaform: [],
			chooseStatus: [],
			choosePayments: [],
			Totale: 0,
			Fee: 0,
			Refund: 0,
			Gain: 0,
			page: 1,

			//Invoice Fattureincloud
			TypeInvoice: '',
			InvoiceItem: '',
			magento: false,
			shopify: false,
			prestashop: false,
			woocommerce: false,
			fattureincloud: false,
			dialogOrderSupplier: false,
			dateOrderSupplier: '',
			checkInPreparazione: true,
			checkRollbackInPreparazione: false,
			operation: '',
			menu: false,
		};
	},

	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},

	created() {},
	async mounted() {
		this.setDialog(false);
		this.setExistFilter(true);
		// stato della lista (pagina, filtri, ricerca) letto dall'URL in data()
		this.listLoad();
		// this.linkdownload = `${this.getUrl}nocors/orders/download`;
	},
	components: {
		TourOverlay,
		KeyValueCard,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',
			getPackingLists: 'packingLists/getPackingLists',
			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getIndex: 'packingLists/getIndex',
			getDrawerFilter: 'settings/getDrawerFilter',
			getSortBy: 'packingLists/getSortBy',
			getSortDesc: 'packingLists/getSortDesc',
			getLanguage: 'profile/getLanguage',
		}),

		navStateFilter: {
			get: function () {
				return this.getDrawerFilter;
			},
			set: function () {
				return this.getDrawerFilter;
			},
		},
		filteredItems() {
			let filters = this.getPackingLists;

			filters = filters.filter(d => {
				if (this.parseDate.length === 1) {
					return (
						d.start_date >
						moment(this.parseDate[0] + ' 00:00:00')
							.utc()
							.format()
					);
				}
				if (this.parseDate.length === 2) {
					return (
						d.start_date >
							moment(this.parseDate[0] + ' 00:00:00')
								.utc()
								.format() &&
						d.start_date <
							moment(this.parseDate[1] + ' 23:59:59')
								.utc()
								.format()
					);
				}
				return d;
			});

			filters = filters.filter(d => {
				if (this.chooseStatus.length > 0) {
					return this.chooseStatus.includes(d.Status);
				}
				return d;
			});

			return filters;
		},
		computedDatejs() {
			let arrayDate = [];
			if (this.settings.filters.start_date && this.settings.filters.start_date.length > 0) {
				this.settings.filters.start_date.forEach(value => {
					arrayDate.push(moment(value).format('DD/MM/YYYY'));
				});
				return arrayDate.join(' ~ ');
			} else {
				return '';
			}
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',

			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',

			setOrder: 'orders/setOrder',
			setPackingLists: 'packingLists/setPackingLists',
			setPackingList: 'packingLists/setPackingList',
			setIndex: 'packingLists/setIndex',

			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
			setSnackbarApp: 'settings/setSnackbar',
		}),
		...mapActions({
			fetchPackingLists: 'packingLists/asyncFetchData',
			destroyData: 'packingLists/destroyData',
			saveData: 'users/saveData',
			fetchSetting: 'settings/asyncFetchData',
		}),
		primoOrdine(item) {
			return (item.order && item.order[0]) || null;
		},
		// titolo della card: riferimento ordine + cliente
		titoloCard(item) {
			const ordine = this.primoOrdine(item);
			const cliente = ordine && ordine.buyer ? `${ordine.buyer.name || ''} ${ordine.buyer.lastname || ''}`.trim() : '';
			return [item.order_number, cliente].filter(Boolean).join(' - ') || 'Packing list';
		},
		// coppie chiave/valore della card (vista telefono)
		campiCard(item) {
			const data = v => (v ? this.$moment(v).format('DD/MM/YYYY HH:mm:ss') : '');
			return [
				{ label: 'Data Inizio', value: data(item.start_date) },
				{ label: 'Data Fine', value: data(item.finish_date) },
				{ label: 'Coupon', value: item.coupon !== 'false' ? item.coupon : '' },
				{ label: 'Ultimo aggiornamento', value: data(item.updated_at) },
			];
		},
		// ricerca da tre caratteri; il caricamento lo fa listRouteState
		getSearch() {
			this.settings.search = _.size(this.searchfield.trim()) >= 3 ? this.searchfield.trim() : '';
		},

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		toggleDrawerFilter() {
			this.setDrawerFilter(!this.getDrawerFilter);
			this.clippedOrder = 0;
		},
		columnValueList(val) {
			return this.getPackingLists.map(d => d[val]);
		},
		cleardate() {
			this.parseDate = [];
			this.settings.filters.start_date = [];
		},

		editItem(item) {
			if (item && item._id) this.$router.push(`/packing-list/${item._id}`);
		},

		editOrder(list) {
			// l'ordine si apre come pagina; Annulla/Salva tornano qui
			const order = list && list.order && list.order[0];
			if (order) openWithReturn(this, { path: `/orders/${order._id}` }, { label: 'Torna alle packing list' });
		},

		toggleClass(num) {
			if (num === 1) {
				this.active = !this.active;
			}
			if (this.active) {
				return 'active';
			} else {
				return 'notActive';
			}
		},


		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.isActive = true;

				let items = this.fetchPackingLists(this.settings);
				items.then(result => {
					this.total = result.total;
					//this.items = result.data.data
					this.setPreload(false);
				});
			} catch (err) {
				console.log(err);
			}
		},
		openNew() {
			this.$router.push('/packing-list/new');
		},

		getImageMarketplace(img) {
			let logo = '';
			switch (img) {
				case 'Amazon':
					logo = require(`@/assets/images/Amazon.svg`);
					break;
				case 'Ebay':
					logo = require(`@/assets/images/Ebay.svg`);
					break;
				case 'Magento':
					logo = require(`@/assets/images/Magento.svg`);
					break;
				case 'Shopify':
					logo = require(`@/assets/images/framework/shopify.svg`);
					break;
				case 'Store':
					logo = require(`@/assets/images/store.svg`);
					break;
				default:
					logo = require(`@/assets/images/flag/map.svg`);
			}
			return logo;
		},
		getImageFlag(img) {
			try {
				return require(`@/assets/images/flag/${img.Country}.svg`);
			} catch (e) {
				return require(`@/assets/images/flag/map.svg`);
			}
		},
		closeSnackbar() {
			this.setSnackbar(false);
		},

	},
	beforeDestroy() {
		// Se si lascia la pagina a giro aperto, vanno staccati i listener del tutorial.
		this.tour.stop();
		this.destroyData();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.packing-cards,
.packing-cards tr {
	display: block;
	width: 100%;
}
.packing-cards tr,
.packing-cards tr:hover {
	background: transparent !important;
}
.packing-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.packing-cards tr:first-child td {
	padding-top: 12px !important;
}
.packing-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.packing-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
